import { isNil } from "lodash-es";
import { ViewTag } from "../models/TrendingModels";

export const areRangesSimilar = (tag1: ViewTag, tag2: ViewTag) => {
	if (
		isNil(tag1.MaxScale) ||
		isNil(tag1.MinScale) ||
		isNil(tag2.MaxScale) ||
		isNil(tag2.MinScale)
	)
		return;

	const range1 = tag1.MaxScale - tag1.MinScale; // Rango de la primera etiqueta
	const range2 = tag2.MaxScale - tag2.MinScale; // Rango de la segunda etiqueta

	// Determina los límites para la comparación
	const lowerBound = Math.max(tag1.MinScale, tag2.MinScale);
	const upperBound = Math.min(tag1.MaxScale, tag2.MaxScale);

	// Calcula el solapamiento entre los dos rangos
	const overlap = Math.max(0, upperBound - lowerBound);

	// Determina si el solapamiento es significativo comparado con los rangos individuales
	const isSignificantOverlap = overlap / range1 > 0.5 && overlap / range2 > 0.5;

	return isSignificantOverlap;
};
